// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueKonva from 'vue-konva'
import VueResource from 'vue-resource'

import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import countrylist from './assets/countries.json'

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueKonva)
Vue.use(VueResource)
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    lang: 'hu',
    _id: '',
    countries: countrylist,
    measurements: [],
    demos: []
  },
  mutations: {
    changeLang (state, lang) {
      state.lang = lang
    },
    setId (state,id){
      state._id = id
    },
    addMeasurement(state,measurement){
      state.measurements.push(measurement)
    },
    addDemo(state,demo){
      state.demos.push(demo)
      console.log("demos")
      console.log(state.demos)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }

})



// WEBPACK FOOTER //
// ./src/main.js